import React from "react";
import "./PlanUsage.css";
import { Link } from "react-router-dom";
import { FormattedMessage, FormattedDate } from "react-intl";
import { IonItem, IonLabel } from "@ionic/react";
import { Settings } from "../interfaces";

const PlanUsage: React.FC<ILayoutProps> = (props: ILayoutProps) => {
  const { totalMessages, messageLimit, endDate, messagesUsed } =
    props.settings.status.plan;
  const { isMobile, path } = props;

  const total = Intl.NumberFormat("en-US").format(totalMessages);
  const limit = Intl.NumberFormat("en-US").format(messageLimit);

  const progressBar = (
    <div className="progress progress-usage visito-cool-progress-bar">
      <div
        className="progress-bar"
        role="progressbar"
        aria-valuenow={1}
        aria-valuemin={0}
        aria-valuemax={100}
        style={{ width: messagesUsed + "%" }}
      ></div>
    </div>
  );

  return isMobile ? (
    <>
      <IonItem>
        <IonLabel>
          <FormattedMessage id="home.messageLimit" />
        </IonLabel>
        <div slot="end">
          <strong>
            {total} / {limit}
          </strong>
        </div>
      </IonItem>
      <IonItem>
        <div style={{ width: "100%" }}>{progressBar}</div>
      </IonItem>
      <IonItem>
        <IonLabel>
          <FormattedMessage
            id="home.dateLimit"
            values={{
              date: (
                <FormattedDate
                  value={endDate}
                  timeZone="UTC"
                  day="numeric"
                  month="short"
                  year="numeric"
                />
              ),
            }}
          />
        </IonLabel>
      </IonItem>
    </>
  ) : (
    <div id="plan-usage-chart" className="visito-card">
      <div className="visito-card-body">
        <h3 className="fs-3 mb-0">
          <FormattedMessage id="home.messageLimit" />
        </h3>

        <div className="progress-info">
          <div className="statsWidgetNumber">
            {total} / {limit}
          </div>
        </div>
        {progressBar}
      </div>
      <div className="visito-card-footer">
        <div className="d-flex justify-content-between align-items-center">
          <div className="fs-3 color-step-600">
            <FormattedMessage
              id="home.dateLimit"
              values={{
                date: (
                  <FormattedDate
                    value={endDate}
                    timeZone="UTC"
                    day="numeric"
                    month="short"
                    year="numeric"
                  />
                ),
              }}
            />
          </div>

          {path != "/settings/payment" ? (
            <Link
              to="settings/payment"
              className="btn btn-visito-outline btn-sm"
            >
              <FormattedMessage id="home.increaseLimit"></FormattedMessage>
            </Link>
          ) : null}
        </div>
      </div>
    </div>
  );
};

interface ILayoutProps {
  settings: Settings;
  path?: string;
  isMobile?: boolean;
}

export default PlanUsage;
